import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import { ApiCaller } from "@/ApiCaller";
import { Config } from "@/plugins/config";

axios.defaults.baseURL = Config.Api;

//accessToken
const authStorage = localStorage.getItem(Config.LocalStorage);

// Tries to get saved storage state
let authStorageParsed;
try {
  authStorageParsed = JSON.parse(authStorage as string);
} catch (err) {
  authStorageParsed = undefined;
}

// Sets default token to axios
if (authStorageParsed) {
  const accessToken = authStorageParsed.authModule.accessToken;
  if (accessToken) {
    ApiCaller.getInstance().configureHeaders(accessToken);
  }
}

Vue.use(VueAxios, axios);
